import { combineReducers } from "redux";
import authReducer from "../../reducers/authSlice"; // 引入 authSlice

const rootReducer = combineReducers({
	auth: authReducer,
	// 其他 reducers 可以在這裡加入
});

export default rootReducer;
